import React, { useState } from "react";
import classes from "../styles.module.scss";
import CoatOfArms from "../../../../assets/images/coat-of-arms.png";
import { ChevronRightIcon } from "../../../../assets/icons";
import { useKato } from "../../../../contexts/kato.context";
import { oblast } from "../../../../consts/kato.conts";
import { useTranslation } from "react-i18next";
import { getLang } from "../../../../helpers/utils";
import { KatoType } from "../../../../types/kato.types";
import { useParams } from "react-router-dom";
import RegionsTree from "./regions-tree.component";

const Current = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { kato } = useParams<{ kato: string }>();
  const { currentLevel, katoTree } = useKato();
  const lang = getLang();

  const getNames = (): { main: string; sub: string } => {
    const regions = katoTree;
    const katoCode = Number(kato);

    const getName = (node?: any) => node?.[`name${lang}`] || "";

    if (!katoCode || !currentLevel) {
      return { main: getName(oblast), sub: t("Kazakhstan") };
    }

    switch (currentLevel) {
      case KatoType.REGION:
      case KatoType.CITY: {
        const region = regions.find((r) => +r.kato === katoCode);

        return {
          main: getName(region),
          sub:
            region?.type === KatoType.CITY ? getName(oblast) : t("Kazakhstan"),
        };
      }

      case KatoType.DISTRICT: {
        for (const region of regions) {
          const district = region.children?.find(
            (child) => +child.kato === katoCode
          );
          if (district) {
            return { main: getName(district), sub: getName(region) };
          }
        }
        break;
      }

      case KatoType.VILLAGE: {
        for (const region of regions) {
          for (const district of region.children || []) {
            const village = district.children?.find(
              (grand) => +grand.kato === katoCode
            );
            if (village) {
              return {
                main: getName(village),
                sub: `${getName(district)} (${getName(region)})`,
              };
            }
          }
        }
        break;
      }

      default:
        break;
    }

    return { main: getName(oblast), sub: t("Kazakhstan") };
  };

  const names = getNames();

  return (
    <>
      <div className={classes.current} onClick={() => setIsOpen(true)}>
        <div className={classes.current__logo}>
          <img src={CoatOfArms} alt="Aktobe Logo" />
        </div>
        <div className={classes.current__names}>
          <div className={classes.current__main}>{names.main}</div>
          <div className={classes.current__sub}>{names.sub}</div>
        </div>
        <div className={classes.current__icon}>
          <ChevronRightIcon />
        </div>
      </div>
      <RegionsTree isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default Current;
